import axios from "axios";

export default async function enquiry(body) {
  await axios
    .post("https://kalyanimotorsapi.kalyanimotors.com/api/enquiry", body)
    .then(() => {})
    .catch(() => {});
  return;
}



